export const registerReducer = state => ({
  ...state,
});
